let isOnCompletePage = false;
let verificationBackCallback: (() => void) | null = null;

/**
 * 미성년자 인증 플로우를 컴포넌트 외부에서 제어할 수 있는 브리지 함수들
 * Vanilla JS 에서 사용
 */
const UnderagePageBridge = {
  /**
   * complete 페이지 진입 시 호출
   */
  setOnCompletePage: (value: boolean) => {
    isOnCompletePage = value;
  },

  /**
   * verification 페이지 뒤로가기 콜백 등록
   * 페이지 마운트 시 등록, 언마운트 시 null로 해제
   */
  setVerificationBackCallback: (callback: (() => void) | null) => {
    verificationBackCallback = callback;
  },

  /**
   * 뒤로가기 버튼 처리
   * complete 페이지에 있으면 true 반환 (백버튼 차단)
   * verification 페이지에 있으면 콜백 호출 후 true 반환
   */
  processBackButton: () => {
    if (isOnCompletePage) return true;
    if (verificationBackCallback) {
      verificationBackCallback();
      return true;
    }
    return false;
  },
};

export default UnderagePageBridge;
